import { render, staticRenderFns } from "./PurchaseClosed.vue?vue&type=template&id=733ad5b5&"
import script from "./PurchaseClosed.vue?vue&type=script&lang=js&"
export * from "./PurchaseClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports